import React, {useContext, useEffect, useState} from "react";
import {ClientContext} from "./ClientView";
import {TabbedPageHeader} from "../../../../../components/TabbedPageHeader";
import {GetBookingsResponse, GetClientBookingsRequest, space} from "../../../../../provider_api";
import {useRpcSender} from "../../../../../util/RpcSender";
import {RpcState} from "../../../../../util/RpcState";
import {KensuTable} from "../../../../../components/table/KensuTable";
import {shortDateTimeFormat} from "../../../../../util/DateTimeUtils";
import IApiBookingProto = space.kenko.proto.IApiBookingProto;
import {fullName, PaymentStatusWidget} from "../../../../../util/BookingUtil";
import {useNavigate} from "react-router-dom";

import {useNavigateWithParams} from "../../../../../util/NavUtils";
import {LoadingDots} from "../../../../../util/UI/LoadingDots";

export const ClientBookings = () => {

  const {client} = useContext(ClientContext);
  const rpcSender = useRpcSender();
  const navigate = useNavigateWithParams();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'pending'});
  const [bookings, setBookings] = useState<IApiBookingProto[]>();

  // Load attendees if editing. New events obviously have no signups.
  useEffect(() => {

    // loading the client in the context can take a second
    if (!client) {
      return;
    }
    
    const request = GetClientBookingsRequest.encode(new GetClientBookingsRequest({
      userId: client?.user?.userId
    })).finish()

    rpcSender.send("get_client_bookings", request)
        .then(bytes => {
          const response = GetBookingsResponse.decode(bytes);
          
          if (!response.okay) {
            setRpcState({state: 'error', message: 'Error loading bookings'})
            return;
          }

          setBookings(response.booking);
          setRpcState({state: 'success'});
        })
        .catch(e => {
          console.log(e);
          setRpcState({state: 'error', message: 'Network error loading bookings: ' + e})
        })
  }, [client])

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={`Client: ${fullName(client?.user)}`}
                      buttons={[{text: 'Back to Clients', link: '../..', isSecondary: true}]}
                      tabs={[
                        {label: 'Profile', link: '../'},
                        {label: 'Bookings', link: './', isSelected: true},
                        {label: 'Payments', link: '../transactions'},
                      ]}
    />

    <div className={'ProviderToolAreaContent'}>

      <h2>Bookings</h2>
      <KensuTable<IApiBookingProto>
          onRowSelected={row => navigate("/home/bookings/" + row.bookingId)}
          data={bookings}
          defaultSort={{ascending: false, columnIndex: 0}} // sort on date
          columns={[
            {
              label: 'Date/Time',
              render: row => shortDateTimeFormat(new Date(row.startTimeMs as number)),
              sortOrder: row => row.startTimeMs
            },
            {label: 'Class/Service', render: row => getTitle(row), sortString: row => getTitle(row)},
            {label: 'Payment Status', render: row => <PaymentStatusWidget booking={row}/>},
            {label: 'Booked at', render: row => shortDateTimeFormat(new Date(row.details?.bookingTimestamp as number)), sortOrder: row => row.details?.bookingTimestamp},
          ]}/>

      {rpcState.state == 'pending' && !bookings?.length && <div>Loading<LoadingDots/></div>}
      {rpcState.state == 'error' && <div className={'ErrorText'}>{rpcState.message}</div>}


    </div>
  </div>

}

const getTitle = (booking?: IApiBookingProto) => {
  if (booking?.details?.class) {
    return booking.details.class.className;
  }

  if (booking?.details?.service) {
    return booking.details.service.serviceName;
  }

  return "";
}